import axios from "axios";
import { config } from "./config";
import apiClient from "./apiClient";

// const apiClient = axios.create({
//     baseURL: config.API_URL,
//     headers: { "Content-Type": "application/json" },
// });

export const loginService = async (email: string, password: string) => {
    try {
        const response = await apiClient.post("/auth/login", { email, password });
        return {
            access_token: response.data.access_token,
            refresh_token: response.data.refresh_token,
        };
    } catch (error: any) {
        if (error.response) {
            console.error(
                "Error in loginService - response data:",
                error.response.data
            );
            console.error("Status code:", error.response.status);
        } else if (error.request) {
            console.error("Error in loginService - no response:", error.request);
            console.log("Error message:", error.message);
        } else {
            console.error("Error in loginService:", error.message);
        }
        throw error;
    }
};

export const registerService = async (userData: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
}) => {
    try {
        const response = await apiClient.post("/auth/register", userData);
        return { token: response.data.access_token, user: response.data.user };
    } catch (error: any) {
        if (error.response) {
            console.error(
                "Error in registerService - response data:",
                error.response.data
            );
            console.error("Status code:", error.response.status);
        } else if (error.request) {
            console.error("Error in registerService - no response:", error.request);
        } else {
            console.error("Error in registerService:", error.message);
        }
        throw error;
    }
};

export const getUserProfile = async (token: string) => {
    try {
      const response = await apiClient.get("/auth/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error("Error fetching profile - response:", error.response.data);
      } else if (error.request) {
        console.error("Error fetching profile - no response:", error.request);
      } else {
        console.error("Error fetching profile:", error.message);
      }
      throw error;
    }
  };


export const resetPassword = async (
  token: string,
  currentPassword: string,
  newPassword: string
) => {
  try {
    const response = await apiClient.post(
      "/auth/reset-password",
      {
        currentPassword,
        newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("Error resetting password - response:", error.response.data);
    } else if (error.request) {
      console.error("Error resetting password - no response:", error.request);
    } else {
      console.error("Error resetting password:", error.message);
    }
    throw error;
  }
};

export const adminResetPassword = async (userId: string, newPassword: string) => {
  try {
    const response = await apiClient.post('/auth/admin/reset-password', {
      userId,
      newPassword,
    });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error('Error resetting password - response:', error.response.data);
    } else if (error.request) {
      console.error('Error resetting password - no response:', error.request);
    } else {
      console.error('Error resetting password:', error.message);
    }
    throw error;
  }
};

export const sendForgotPasswordEmail = async (email: string) => {
  try {
    const response = await apiClient.post("/auth/forgot-password", { email });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("Error sending forgot password email - response:", error.response.data);
    } else if (error.request) {
      console.error("Error sending forgot password email - no response:", error.request);
    } else {
      console.error("Error sending forgot password email:", error.message);
    }
    throw error;
  }
};

export const resetPasswordWithTokenService = async (token: string, newPassword: string) => {
  const response = await axios.post(`${config.API_URL}/auth/reset-password/${token}`, {
    newPassword,
  });
  return response.data;
};

export const getUsers = async () => {
  try {
    const response = await apiClient.get('/auth/users');
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error('Error getting users - response:', error.response.data);
    } else if (error.request) {
      console.error('Error getting users - no response:', error.request);
    } else {
      console.error('Error getting users:', error.message);
    }
    throw error;
  }
};
